export const INCENTIVE_STATES = {
  REWARD: 'REWARD',
  NO_PAYMENT: 'NO_PAYMENT',
  PENDING: 'PENDING',
  PENALTY: 'PENALTY',
  T_NO_SHOW: 'T_NO_SHOW',
};

export const EVENT_TYPE = {
  DEMO_ENROLLED: 'DEMO_ENROLLED',
  DEMO_COMPLETED: 'DEMO_COMPLETED',
  DEMO_TEACHER_NO_SHOW: 'DEMO_TEACHER_NO_SHOW',
};

export const ACTIONS_LABEL = {
  ADD_ENROLLMENT_INCENTIVE: 'Add Enrol Incentive',
  REMOVE_PENALTY: 'Remove Penalty',
  ADD_DEMO_INCENTIVE: 'Add Demo Incentive',
  REMOVE_DEMO_INCENTIVE: 'Remove Demo Incentive',
  REMOVE_ENROLLMENT_INCENTIVE: 'Remove Enrol Incentive',
  PAYMENT_ID: 'Payment Id',
  OTHER: 'Other',
  CREATE_DEMO_INCENTIVE: 'Create Demo Incentive',
};

export const MathProduct = 'MTH_ONLINE_WT_TCHR';
export const CodingProduct = 'CODING';
export const Remove = 'Remove';
export const Add = 'Add';
export const PaymentId = 'Payment ID';

export const INCENTIVE_ACTIONS = {
  'Add Demo Incentive': 'ADD_DEMO_INCENTIVE',
  'Remove Demo Incentive': 'REMOVE_DEMO_INCENTIVE',
  'Add Enrol Incentive': 'ADD_ENROLLMENT_INCENTIVE',
  'Create Demo Incentive': 'CREATE_DEMO_INCENTIVE',
  'Remove Enrol Incentive': 'REMOVE_ENROLLMENT_INCENTIVE',
  'Remove Penalty': 'REMOVE_PENALTY',
};

export const OtherOption = 'Other (enter the reason in the blank)';

export const PaymentLinkInfoDetails =
  'Access the payment information for the student by scrolling to the bottom of the student page on Leap-admin.';

const ReasonForAddingDemoInc = 'Reason for adding demo incentive';
const ReasonForRemovingDemoInc = 'Reason for removing demo incentive';
const ReasonForRemovePenalty = 'Reason for removing penalty';
const ReasonForAddingEnrolInc = 'Reason for adding enrol incentives';
const ReasonForCreatingDemoInc = 'Reason for creating demo incentive';
const ReasonForRemovingEnrolInc = 'Reason for removing enrol incentives';

export function ReasonsTitle(title) {
  const {
    ADD_DEMO_INCENTIVE,
    ADD_ENROLLMENT_INCENTIVE,
    CREATE_DEMO_INCENTIVE,
    OTHER,
    PAYMENT_ID,
    REMOVE_DEMO_INCENTIVE,
    REMOVE_ENROLLMENT_INCENTIVE,
    REMOVE_PENALTY,
  } = ACTIONS_LABEL;
  switch (title) {
    case ADD_DEMO_INCENTIVE:
      return ReasonForAddingDemoInc;
    case REMOVE_DEMO_INCENTIVE:
      return ReasonForRemovingDemoInc;
    case REMOVE_PENALTY:
      return ReasonForRemovePenalty;
    case ADD_ENROLLMENT_INCENTIVE:
      return ReasonForAddingEnrolInc;
    case CREATE_DEMO_INCENTIVE:
      return ReasonForCreatingDemoInc;
    case REMOVE_ENROLLMENT_INCENTIVE:
      return ReasonForRemovingEnrolInc;
    case PAYMENT_ID:
      return PaymentId;
    case OTHER:
      return 'Type your reason';
    default:
      return null;
  }
}
